<template>
    <div class="card-body" style="display: flex; column-gap: 10px">
        <div class="filter-block">
            <div class="filter-block-left">
                <Select
                    v-if="hasActions"
                    :title="translate('components.datatable.actions')"
                    :options="lists.actions"
                    :disabled="disabledActions"
                    @update:modelValue="newValue => $emit('select:action', newValue)"
                />
                <Input
                    :value="search"
                    @update:value="changeSearch"
                    icon="icon-search4"
                    :placeholder="translate('components.datatable.search')"
                />
                <div v-for="selectedFilter in selectedFilters">
                    <Select
                        v-if="['select', 'multiselect'].includes(selectedFilter.type)"
                        v-model="filters[selectedFilter.name]"
                        :options="selectedFilter.options"
                        :title="translate(selectedFilter.title)"
                        :is-multi="selectedFilter.type === 'multiselect'"
                        :has-search="true"
                    />
                    <FromToDates
                        v-if="['from_to_dates'].includes(selectedFilter.type)"
                        :title="translate(selectedFilter.title)"
                        v-model:from="filters[selectedFilter.name].from"
                        v-model:to="filters[selectedFilter.name].to"
                    />
                    <FromToNumbers
                        v-if="['from_to_numbers'].includes(selectedFilter.type)"
                        :title="translate(selectedFilter.title)"
                        v-model:from="filters[selectedFilter.name].from"
                        v-model:to="filters[selectedFilter.name].to"
                    />
                    <MultiAutocomplete
                        v-if="['multiautocomplete'].includes(selectedFilter.type)"
                        :title="translate(selectedFilter.title)"
                        :url-props="filters[selectedFilter.name].url"
                        v-model:model-value="filters[selectedFilter.name]"
                    />
                    <NewMultiAutocomplete
                        v-if="['new-multiautocomplete'].includes(selectedFilter.type)"
                        v-model:model-value="filters[selectedFilter.name]"
                        :url="selectedFilter.url"
                        :title="selectedFilter.title"
                        :group-value="selectedFilter.groupValue"
                    />
                </div>
                <Select
                    v-if="config.filters.filter(filter => filter.default === 0).length > 0"
                    :options="lists.filters"
                    :modelValue="selectedFilterNames"
                    @update:modelValue="changeFilters"
                    :is-multi="true"
                    :title-can-change="false"
                    :title="translate('components.datatable.add_filter')"
                    icon="icon-plus3"
                />
                <Button
                    v-if="filters.length > 0"
                    title="Скинути фільтри"
                    icon="icon-eraser2"
                    @click="filters = {}"
                />
            </div>
            <div class="filter-block-right">
                <Select
                    v-if="config.hasTemplates"
                    :title="translate('components.datatable.template')"
                    :options="templateOptions"
                    :modelValue="config.templateUuid"
                    :has-search="true"
                    :disabled="templates.length === 0"
                    @update:modelValue="selectTemplate"
                />
                <AlphaButton
                    v-if="config.hasTemplates"
                    color="indigo"
                    @click="showUpsertTemplateModal"
                >{{ translate('buttons.save') }}</AlphaButton>

                <Select
                    :title="translate('components.datatable.show')"
                    :options="lists.limits"
                    :modelValue="limit"
                    @update:modelValue="changeLimit"
                />
            </div>
        </div>
        <UpsertTemplateModal ref="upsertTemplateModal" />
    </div>

</template>

<script>
import Select from "./filters/SelectComponent.vue";
import Input from "./filters/InputComponent.vue";
import Button from "./filters/ButtonComponent.vue";
import AlphaButton from "../button/AlphaButton.vue";
import FromToDates from "./filters/FromToDatesComponent.vue";
import FromToNumbers from "./filters/FromToNumbersComponent.vue";
import UpsertTemplateModal from "./modals/UpsertTemplateModal.vue";
import MultiAutocomplete from "./filters/MultiAutocompleteComponent.vue";
import NewMultiAutocomplete from "../form/multiautocomplet/Multiautocomplete.vue"
export default {
    name: 'FilterComponent',
    components: {Select, Input, Button, FromToDates, UpsertTemplateModal, FromToNumbers, MultiAutocomplete, NewMultiAutocomplete, AlphaButton},
    emits: ['update:filters', 'update:search', 'update:limit', 'update:orders', 'select:action', 'action:reload'],
    props: ['search', 'limit', 'orders', 'config', 'hasActions', 'selectedColumns', 'disabledActions'],
    data() {
        return {
            lists: {
                actions: this.config.actions.map(action => ({key: action.name, value: translate(action.title)})),
                filters: this.config.filters.map(filter => ({key: filter.name, value: translate(filter.title)})),
                limits: [{key: 10, value: "10"}, {key: 25, value: "25"}, {key: 50, value: "50"}, {key: 100, value: "100"},]
            },
            filterItems: this.config.filters,
            filters: {},
            templates: [],
            template: {
                uuid: null,
                name: null,
                main: false,
                personal: true
            }
        }
    },
    methods: {
        setAdditionalData(data) {
            this.filterItems = this.config.filters

            this.templates = data.templates ?? [];

            let filteredTemplates = data.templates.filter((template) => (template.uuid === this.config.templateUuid))

            if (filteredTemplates.length > 0 && this.config.templateUuid != null) {
                let template = filteredTemplates[0];

                this.template.uuid = template.uuid;
                this.template.name = template.name;
                this.template.main = template.main;
                this.template.personal = template.personal;
                this.filters = JSON.stringify(template.cache.filters) !== '[]' ? template.cache.filters : {};
                if (template.cache.filters?.created_at?.to === null && template.cache.filters?.created_at?.from === null) {
                    this.setDefaultDate()
                }
                this.$emit('update:orders', template.cache.orders)
                this.changeLimit(template.cache.limit, false)
            } else {
                this.filters = {};
                this.config.filters.forEach(filter => {
                    if (filter.default === 1) this.filters[filter.name] = filter.value;
                });
                this.setDefaultDate();
            }
        },
        selectTemplate(uuid) {
            if (Array.isArray(uuid)) {
                uuid = uuid[0] ?? null;
            }

            let query = {...this.$route.query};

            if (uuid) {
                query.template = uuid;
            } else {
                delete query.template;
            }

            this.$router.push({query});
        },
        showUpsertTemplateModal() {
            this.$refs.upsertTemplateModal.show(this.template, {
                columns: this.selectedColumnNames,
                orders: this.orders,
                limit: this.limit,
                filters: this.filters
            }, this.config)
        },
        changeLimit(newValue, withReload = true) {
            this.$emit('update:limit', newValue)

            if (withReload) {
                this.$emit('action:reload')
            }
        },
        changeFilters(newValue, withReload = true) {
            newValue.map((filterName) => {
                if (!this.filters[filterName]) {
                    let findFilter = this.config.filters.filter(filter => filter.name === filterName)[0];

                    this.filters[filterName] = findFilter.value;
                }
            });
            for (const key in this.filters) {
                if (!newValue.includes(key)) {
                    delete this.filters[key];
                }
            }
            this.$emit('update:filters', this.filters)
        },
        getCleanFilters() {
            let cleanedFilters = {};

            for (const key in this.filters) {
                const value = this.filters[key];

                if (Array.isArray(value) && value.length === 0) {
                    continue;
                }

                if (value !== null && typeof value === 'object' && 'from' in value && 'to' in value && value.from === null && value.to === null) {
                    continue;
                }

                cleanedFilters[key] = value;
            }

            return cleanedFilters;
        },
        changeSearch(newValue, withReload = true){
            this.$emit('update:search', newValue)

            if (withReload) {
                this.$emit('action:reload')
            }
        },
        setDefaultDate() {

            //  Потрібно мати можливість підставляти дату створення "від" і "до" по замовчування, щоб обмежити вибір даних в запросів, передбачити це для полів іншого типу

            let filtered = this.config.filters.filter(filter => filter.type === 'from_to_dates' && filter.default === 1 && filter.name === 'created_at')
            if (filtered.length > 0) {
                const to = new Date();
                const from = new Date();
                from.setDate(to.getDate() - 30);

                this.filters.created_at.to = `${String(to.getFullYear())}-${String(to.getMonth() + 1).padStart(2, '0')}-${String(to.getDate()).padStart(2, '0')}`;
                this.filters.created_at.from = `${String(from.getFullYear())}-${String(from.getMonth() + 1).padStart(2, '0')}-${String(from.getDate()).padStart(2, '0')}`;
            }
        }
    },
    computed: {
        templateOptions() {
            return this.templates.map(template => ({key: template.uuid, value: template.name}));
        },
        selectedFilters() {
            return this.filterItems.filter(filter => this.selectedFilterNames.includes(filter.name))
        },
        selectedColumnNames() {
            return this.selectedColumns;
        },
        selectedFilterNames() {
            return Object.keys(this.filters)
        }
    },
    mounted() {
        this.config.filters.map(filter => filter.default === 1 ? this.filters[filter.name] = filter.value : null)
    },
    watch: {
        'filters': {
            handler(newValue, oldValue) {
                const cleanedFilters = this.getCleanFilters();

                this.$emit('update:filters', cleanedFilters)
                this.$emit('action:reload')
            },
            deep: true
        },
    }
}
</script>

<style>
.filter-block {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.filter-block > div  {
    display: flex;
    column-gap: 10px;
}
.diff-line {
    background: #eaeaea;
    width: 1px;
}
</style>
